<template>
  <div  :class="{english:$i18n.locale=='en'}">
    <HeaderLine index="12" ref="dialog" showbar="true" @on-locale-change="onLocaleChange">
      {{$t('software.name')}}
    </HeaderLine>
     <div class="banner" style="height:5rem">
         <img :src="imglist[0]" alt="">    
     </div>
    <div class="introduction center">
      <ul class="download_list main_wrap">
        <li class="download_list_item">
          <h3 class="download_item_title" id="anchor1" v-html="$t('software.introduction_title')"></h3>
          <h4 class="download_item_title2" v-html="$t('software.introduction_title2')" style="line-height: 1.6em"></h4>
          <ul class="download_platforms clearfix platform_pic">
             <li>
              <div class="pic_box">
                <div class="pic_mask2">
                    <a href="https://a.app.qq.com/o/simple.jsp?pkgname=com.vrviu.lightvr" class="button3" target="_blank">{{$t('software.download')}}</a>                
                </div>
                <img src="../assets/images/software/icon_cardborad@2x.png" alt="">
              </div>


               <h3 class="platform_name" v-html="$t('software.product_title1')"></h3>
               <p class="platform_info">{{$t('software.product_vison1')}}</p>
               <p class="platform_info" style="margin-bottom:0.35rem">{{$t('software.product_date1')}}</p>
               
             </li>
             <li>
              <div class="pic_box">
                <div class="pic_mask2">
                    <a href="https://www.vrviu.com/static/download/sdk/LightVR_V2.5_forPico.zip"  class="button3">{{$t('software.download')}}</a>                
                </div>
                <img src="../assets/images/software/icon_Pico@2x.png" alt="">
                
              </div>
               <h3 class="platform_name" v-html="$t('software.product_title2')"></h3>
               <p class="platform_info">{{$t('software.product_vison2')}}</p>
               <p class="platform_info" style="margin-bottom:0.35rem">{{$t('software.product_date2')}}</p>
               
             </li>
             <li>
              <div class="pic_box">
                <div class="pic_mask2">
                    <img src="../assets/images/software/mini_program.jpg" alt="">              
                </div>
              <img src="../assets/images/software/icon_xiao@2x.png" alt="">
                
              </div>
               <h3 class="platform_name" v-html="$t('software.product_title3')"></h3>
               <p class="platform_info">{{$t('software.product_vison3')}}</p>
               <p class="platform_info" style="margin-bottom:0.35rem">{{$t('software.product_date3')}}</p>
               
             </li>
             <li>
              <div class="pic_box">
  <!--               <div class="pic_mask2">
                    <a href="javascript:void(0)"  class="button3">{{$t('software.download')}}</a>                
                </div> -->
              <img src="../assets/images/software/icon_vive@2x.png" alt="">
                
              </div>
               <h3 class="platform_name" v-html="$t('software.product_title4')"></h3>
               <p class="platform_info">{{$t('software.product_vison4')}}</p>
               <p class="platform_info" style="margin-bottom:0.35rem">{{$t('software.product_date4')}}</p>
               
             </li>
             <li>
              <div class="pic_box">
<!--                 <div class="pic_mask2">
                    <a href="javascript:void(0)"  class="button3">{{$t('software.download')}}</a>                
                </div> -->
              <img src="../assets/images/software/icon_oculus@2x.png" alt="">
                
              </div>
               <h3 class="platform_name" v-html="$t('software.product_title5')"></h3>
               <p class="platform_info">{{$t('software.product_vison5')}}</p>
               <p class="platform_info" style="margin-bottom:0.35rem">{{$t('software.product_date5')}}</p>
               
             </li>
             <li>
              <div class="pic_box">
  <!--               <div class="pic_mask2">
                    <a href="javascript:void(0)"  class="button3">{{$t('software.download')}}</a>                
                </div> -->
              <img src="../assets/images/software/icon_MIVR@2x.png" alt="">
                
              </div>
               <h3 class="platform_name" v-html="$t('software.product_title6')"></h3>
               <p class="platform_info">{{$t('software.product_vison6')}}</p>
               <p class="platform_info" style="margin-bottom:0.35rem">{{$t('software.product_date6')}}</p>
               
             </li>
          </ul>
          <h3 class="download_item_title" id="anchor2">{{$t('software.introduction_title3')}}</h3>
          <h4 class="download_item_title2">{{$t('software.introduction_title4')}}</h4>
          <ul class="download_platforms clearfix platform_pic" style="border-bottom:none">
             <li>
              <div class="pic_box">
                <div class="pic_mask2">
                    <a href="https://www.vrviu.com/static/download/sdk/LightEncoder_V1.1.zip"  class="button3">{{$t('software.download')}}</a>                
                </div>
              <img src="../assets/images/software/icon_Window@2x.png" alt="">
                
              </div>
               <h3 class="platform_name" v-html="$t('software.product_title7')"></h3>
               <p class="platform_info">{{$t('software.product_vison7')}}</p>
               <p class="platform_info" style="margin-bottom:0.35rem">{{$t('software.product_date7')}}</p>
               
             </li>
             <li>
              <div class="pic_box">
  <!--               <div class="pic_mask2">
                    <a href="javascript:void(0)"  class="button3">{{$t('software.download')}}</a>                
                </div> -->
              <img src="../assets/images/software/icon_Linux@2x.png" alt="">
                
              </div>
               <h3 class="platform_name" v-html="$t('software.product_title8')"></h3>
               <p class="platform_info">{{$t('software.product_vison8')}}</p>
               <p class="platform_info" style="margin-bottom:0.35rem">{{$t('software.product_date8')}}</p>
               
             </li>
              

           
          </ul>
          <div class="center" style="border-bottom: 1px solid #eee;padding-bottom: 0.7rem">
            <p class="platform_info" style="line-height: 1.6em" v-html="$t('software.introduction_text')"></p>
<a href="javascript:void(0)" @click="showDialog()" class="button_default button_default2">{{$t('product.text45')}}</a>
          </div>

          <h3 class="download_item_title" id="anchor3">{{$t('software.introduction_title5')}}</h3>
          <h4 class="download_item_title2">{{$t('software.introduction_title6')}}</h4>
          <ul class="download_platforms clearfix platform_pic">
             <li>
              <div class="pic_box">
                <div class="pic_mask2">
                    <a href="https://github.com/vrviu-sdk/VBS" target="_blank" class="button3">{{$t('software.download')}}</a>                
                </div>
              <img src="../assets/images/software/icon_Window@2x.png" alt="">
                
              </div>
               <h3 class="platform_name" v-html="$t('software.product_title9')"></h3>
               <p class="platform_info">{{$t('software.product_vison9')}}</p>
               <p class="platform_info" style="margin-bottom:0.35rem">{{$t('software.product_date9')}}</p>
               
             </li>
             <li>
              <div class="pic_box">
                <div class="pic_mask2">
                    <a href="https://github.com/vrviu-sdk/VBS/blob/master/VBSDemoPlayer.apk"  class="button3" target="_blank">{{$t('software.download')}}</a>                
                </div>
              <img src="../assets/images/software/icon_Android@2x.png" alt="">
                
              </div>
               <h3 class="platform_name" v-html="$t('software.product_title10')"></h3>
               <p class="platform_info">{{$t('software.product_vison10')}}</p>
               <p class="platform_info" style="margin-bottom:0.35rem">{{$t('software.product_date10')}}</p>
               
             </li>
           
          </ul>
        </li>
      </ul>

    </div>
    <Footerline></Footerline>
  </div>

</template>
<script>
import HeaderLine from '../components/header.vue';
import Footerline from '../components/footer.vue';
import '../common/css/devolop.css';
import Vue from 'vue';
// import {
//   Carousel,
//   CarouselItem
// } from 'element-ui';
import i18n from '../common/i18n'
// Vue.use(Carousel)
// Vue.use(CarouselItem)




export default {
  name: 'solution',
  data: function() {
    return {
     imglist:[
       "/static/images/devolop/banner.png",
       "/static/images/devolop/01.png",
       "/static/images/devolop/02.png",
       "/static/images/about/Brian.png",
       "/static/images/about/Tim.png",
       "/static/images/about/Joyce.png",
       "/static/images/about/Alen.png",
       "/static/images/about/bg.png"
     ]

    }
  },
  i18n: i18n,
  watch: {

  },
  mounted() {
    var language = navigator.language; //取得浏览器版本语言
    var initLanguage = "";
    if (localStorage.locale) {
      this.$i18n.locale = localStorage.locale;
    } else {
      if (language.indexOf('zh') > -1) {
        initLanguage = "ch"; //中文页面
      } else if (language.indexOf('en') > -1) {
        initLanguage = "en"; //英文页面
      }
      this.$i18n.locale = initLanguage;
    }
  },
  computed: {

  },
  components: {
    HeaderLine,
    Footerline
  },
  methods: {
    changeIndex(dsd, sdsds) {
      this.loopName = this.loopList[dsd].name;
    },
    showDialog2() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Others";

      } else {
        this.$refs.dialog.content_type2 = "其他";

      }
    },
    showDialog3() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "VRVIU Cloud service questions";

      } else {
        this.$refs.dialog.content_type2 = "威尔云服务咨询";

      }
    },
    showDialog() {
      this.$refs.dialog.showDialog = true;
      this.$refs.dialog.showNext = false;
      if (this.$i18n.locale == "en") {
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";

      } else {
        this.$refs.dialog.content_type2 = "威尔云服务咨询";

      }
    },
    onLocaleChange: function(val) {
      this.$i18n.locale = val;
    }
  }
}

</script>
<style scoped>
.carousel_box {
  /*width: 12rem;*/
  margin: 0 auto;
  height: 5.4rem;
}
.download_platforms li{
  width: 3.05rem;
  margin-right:0.44rem!important
}
.download_platforms li:nth-child(2n){
  margin-right: 0
}
.pic_box{
  cursor: pointer;
}
.pic_box:hover .pic_mask2{
      display: block;
}
/*.pic_box:hover > img{
      display: none;
}*/
.pic_mask2{
  height: 2.86rem;
  width: 2.86rem;
  background:rgba(4,3,30,0.6);
  text-align: center;
  display: none;
  left: 0.1rem;
  top:0.1rem;
  position: absolute;
}
.pic_mask2 img{
  height: 100%!important;
  width: 100%!important;
}
.pic_mask2 .button3 {
    width: 2rem;
    margin-top: 1.2rem
}

.platform_pic li img{
  width: 3.05rem;
  height: 3.05rem;
}
.platform_pic{
  width: 6.6rem;
  margin: 0 auto
}
.platform_pic li{
  height: auto;
}
.el-carousel__item.is-active {
  transform: translateX(1.5rem) scale(1) !important;
  width: 12rem;

}
.download_item_title2{
  margin-bottom:0.35rem;
}
.platform_name{
  font-size: 0.28rem!important;
  padding-top: 0.1rem;
}
.platform_name,.platform_info{
  padding-left:0.1rem!important;
  white-space: nowrap;
}
.platform_info{
  font-size: 0.24rem;
}
.platform_pic li:nth-child(2n){
  margin-right: 0!important
}
.platform_name{
  white-space: nowrap;
}
.platform_name .platform_info2{
  font-size:0.18rem;
  color: #646464;
  vertical-align: middle;
}
/*.platform_info{
  margin-bottom:0.4rem;
}*/
</style>



// WEBPACK FOOTER //
// software.vue?075aa1be